import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { Button, Intent } from "@blueprintjs/core";
import {
  StyledDialog,
  Container,
  InputSection,
  StyledFileInput,
  StyledInputLink,
  StyledButtonSave,
} from "./Styles";
import { AttachmentSection } from "./AttachmentSection";
import { LoadingOverlay } from "../overlays";
import messages from "./Attachment.messages";
import AppToaster from "../toasters";
import { Link } from "react-router-dom";

class AttachmentDialogs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      attachment: null,
      link: null,
    };
  }

  onClose = () => {
    const { onClose } = this.props;
    this.setState({ attachment: null });
    this.setState({ link: null });

    onClose();
  };

  onEnterPress = (e) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      this.submit(e);
    }
  };

  showErrorMessage = (err) => {
    AppToaster.show({
      message: err,
      intent: Intent.DANGER,
    });
  };

  onTextChange = (event) => {
    this.setState({ attachment: null });
    this.setState({ link: event.target.value });
  };

  onFileChange = (event) => {
    const {
      props: { intl },
    } = this;

    // Update the state
    if (
      event.target.files.length == 0 ||
      event.target.files[0].size > 40000000
    ) {
      this.setState({ attachment: null });
      this.showErrorMessage(intl.formatMessage(messages.errors.fileToLarge));
    } else {
      this.setState({ link: "" });
      this.setState({ attachment: event.target.files[0] });
    }
  };

  submit = (event) => {
    event.preventDefault();
    const {
      state: { attachment, link },
      props: { submit },
    } = this;

    if (attachment) {
      const reader = new FileReader();

      reader.onload = (ev) => {
        submit(attachment.name, reader.result, null).then(() =>
          this.setState({ attachment: null, link: "" })
        );
      };

      reader.readAsDataURL(attachment);
    } else if (link !== "" || link !== null) {
      submit(null, null, link).then(() =>
        this.setState({ attachment: null, link: "" })
      );
    }
  };

  render() {
    const {
      props: {
        isOpen,
        loading,
        attachments,
        fetchFile,
        removeAttachment,
        intl,
      },
      state: { attachment, link },
    } = this;

    const fileName =
      attachment != null && attachment.name != ""
        ? attachment.name
        : intl.formatMessage(messages.fields.selectAFile);

    const linkUrl =
      link !== null && link !== ""
        ? link
        : intl.formatMessage(messages.fields.orPutAnUrl);

    return (
      <StyledDialog
        title={intl.formatMessage(messages.general.title)}
        isOpen={isOpen}
        onClose={this.onClose}
        canOutsideClickClose={false}
      >
        {loading && <LoadingOverlay />}
        <Container>
          <AttachmentSection
            attachments={attachments}
            fetchFile={fetchFile}
            removeAttachment={removeAttachment}
          />

          <InputSection onSubmit={this.submit}>
            <StyledFileInput
              large
              fill
              text={fileName}
              buttonText={intl.formatMessage(messages.fields.browse)}
              onChange={this.onFileChange}
              hasSelection={attachment != null}
            />
            <StyledInputLink
              large
              fill
              autoResize={false}
              placeholder={linkUrl}
              value={link}
              onChange={this.onTextChange}
            />
            <StyledButtonSave
              intent={Intent.PRIMARY}
              type="submit"
              onClick={this.onFileUpload}
              disabled={!attachment && !link}
            >
              <FormattedMessage {...messages.general.save} />
            </StyledButtonSave>
          </InputSection>
        </Container>
      </StyledDialog>
    );
  }
}

AttachmentDialogs.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  removeAttachment: PropTypes.func.isRequired,
  fetchFile: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  attachments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(AttachmentDialogs);
